import admin from './admin';
import archetypes from './archetypes';
import auth from './auth';
import common from './common';
import contribute from './contribute';
import feedback from './feedback';
import home from './home';
import intro from './intro';
import kompasForms from './kompasForms';
import landing from './landing';
import library from './library';
import nativeCopy from './native';
import nav from './nav';
import quiz from './quiz';
import quizData from './quizData';
import quizInApp from './quizInApp';
import resultsCard from './resultsCard';
import shell from './shell';
import signup from './signup';
import strategicCompass from './strategicCompass';
import teamDashboard from './teamDashboard';
import teamDynamics from './teamDynamics';
import teamInsightText from './teamInsightText';
import teamIntro from './teamIntro';
import teamPanels from './teamPanels';
import teamSelector from './teamSelector';
import teamSignals from './teamSignals';
import workplaceProfile from './workplaceProfile';

const nl = {
  admin,
  archetypes,
  auth,
  common,
  contribute,
  feedback,
  home,
  intro,
  kompasForms,
  landing,
  library,
  native: nativeCopy,
  nav,
  quiz,
  quizData,
  quizInApp,
  resultsCard,
  shell,
  signup,
  strategicCompass,
  teamDashboard,
  teamDynamics,
  teamInsightText,
  teamIntro,
  teamPanels,
  teamSelector,
  teamSignals,
  workplaceProfile,
};

export default nl;
